import {useGoogleMap} from "@react-google-maps/api";
import {useEffect} from "react";

/**
 * Live traffic on the enclosing map. Replaces the library's TrafficLayerF, whose cleanup reads a stale
 * (null) instance and so leaves the traffic drawn after it unmounts.
 */
export const TrafficLayer = () => {
  const map = useGoogleMap();

  useEffect(() => {
    if (!map) return;
    const layer = new google.maps.TrafficLayer({map});
    return () => layer.setMap(null);
  }, [map]);

  return null;
};
